import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useFormikContext } from "formik"; // Importiamo il contesto Formik
import * as apiMedici from "../../../api/medici";

const AsyncMediciSelect = ({ formik, name, authToken, user, showFilters = true }) => {
  // Usiamo il contesto Formik per accedere a values e setFieldValue

  const [inputValue, setInputValue] = useState("");

  const [options, setOptions] = useState([]);
  const [optionsProvince, setProvinceOptions] = useState([]);
  const [optionsSpecializzazioni, setSpecializzazioniOptions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [provincia, setProvincia] = useState("");
  const [specializzazione, setSpecializzazione] = useState("");
  
  useEffect(() => {
    if (!showFilters) {
      setProvinceOptions([]);
      setSpecializzazioniOptions([]);
      return;
    }

    apiMedici.getProvince(user.authToken).then((response) => {
      const data = Array.isArray(response) ? response : response?.data || [];

      // Converti i dati in opzioni per un dropdown/select
      const provinceOptions = Array.isArray(data)
        ? data.map((p) => ({
          value: p.provincia, // assumendo che p abbia una proprietà 'provincia'
          label: p.provincia, // stessa value e label in questo caso
        }))
        : []; // fallback sicuro se data non è un array

      setProvinceOptions(provinceOptions);
    });

    apiMedici.getSpecializzazioni(user.authToken).then((response) => {
      const data = Array.isArray(response) ? response : response?.data || [];

      // Converti i dati in opzioni per un dropdown/select
      const specializzazioniOptions = Array.isArray(data)
        ? data.map((p) => ({
          value: p.specializzazione, // assumendo che p abbia una proprietà 'provincia'
          label: p.specializzazione, // stessa value e label in questo caso
        }))
        : []; // fallback sicuro se data non è un array

      setSpecializzazioniOptions(specializzazioniOptions);
    });
  }, [authToken]);

  useEffect(() => {
    let isMounted = true;
    if (inputValue.length >= 3 || provincia || specializzazione) {
      setIsLoading(true);
      const timer = setTimeout(() => {
        const filters = {
          searchText: inputValue,
          prov: provincia,
          spec: specializzazione,
        };

        apiMedici
          .getByInput(user.authToken, filters)
          .then((response) => {
            if (!isMounted) return;
            // Controlla se la risposta è direttamente l'array
            const data = Array.isArray(response) ? response : response?.data || [];
            const formattedOptions = Array.isArray(data)
              ? data.map((m) => ({
                value: m.id,
                label: m.fullname || `${m.nome} ${m.cognome}`,
                specializzazione: m.specializzazione || "N/D",
                address: m.address || "Indirizzo non disponibile",
              }))
              : [];
            setOptions(formattedOptions);
          })
          .catch((error) => {
            console.error("Errore API:", {
              status: error.response?.status,
              data: error.response?.data,
              message: error.message,
            });
          })
          .finally(() => {
            if (isMounted) setIsLoading(false);
          });
      }, 500);

      return () => clearTimeout(timer);
    } else {
      setOptions([]);
    }
  }, [inputValue, authToken, provincia, specializzazione]);

  return (
    <div className="multi-filter-select">
      {/* Filtro Provincia */}
      
      {showFilters && optionsProvince.length>0 && (
      <div className="mb-2">
        <Select
          options={optionsProvince}
          placeholder="Filtra per provincia..."
          isClearable
          onChange={(selected) => setProvincia(selected?.value || "")}
          styles={{
            control: (provided) => ({
              ...provided,
              minHeight: "40px",
            }),
          }}
        />
      </div>
      )}

      {/* Filtro Specializzazione */}
      {showFilters && optionsProvince.length>0 && (
      <div className="mb-2">
        <Select
          options={optionsSpecializzazioni}
          placeholder="Filtra per specializzazione..."
          isClearable
          onChange={(selected) => setSpecializzazione(selected?.value || "")}
          styles={{
            control: (provided) => ({
              ...provided,
              minHeight: "40px",
            }),
          }}
        />
      </div>
      )}

      {/* Ricerca per Nome */}
      <Select
        value={options.find((m) => m.value === formik.values.idMedico)}
        onChange={(selected) => formik.setFieldValue(name, selected?.value || 0)}
        onInputChange={setInputValue}
        options={options}
        isLoading={isLoading}
        // isDisabled={inputValue.length < 3}
        noOptionsMessage={() =>
          inputValue.length < 3 ? "Digita almeno 3 caratteri per cercare" : "Nessun risultato trovato"
        }
        formatOptionLabel={(e) => (
          <div>
            <div>
              <strong>{e.label}</strong>
            </div>
            <div style={{ fontSize: "0.90em" }}>{e.specializzazione}</div>
            <div style={{ fontSize: "0.85em" }}>{e.address}</div>
          </div>
        )}
        styles={{
          singleValue: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            fontSize: "1rem",
          }),
        }}
        components={{
          SingleValue: ({ children }) => (
            <div style={{ padding: "8px 12px" }} className="react-select__single-value">
              {children}
            </div>
          ),
        }}
      />
    </div>
  );
};

export default React.memo(AsyncMediciSelect);
